import axios from "axios";

const state = {
  Transtions: [],
  loading: false,
  pagination: {
    currentPage: 1,
    pagesTotal: 1,
  },
};

const getters = {
  getTranstions(state) {
    return state.Transtions;
  },
  loading(state) {
    return state.loading;
  },
  pagination(state) {
    return state.pagination;
  },
};

const mutations = {
  SetTranstions(state, payload) {
    state.Transtions = payload;
  },
  setloading(state, payload) {
    state.loading = payload;
  },
  SetPagination(state, payload) {
    state.pagination = payload;
  },
};

const actions = {
  LoadTranstions({ commit }, payload) {
    commit("setloading", true);
    commit("setSnackbar", false);
    axios
      .post(
        `https://backoffice.teller.ng/TellerAppManager/api/TransactionHistoryRequest?customerID=${payload.customerID}&pin=${payload.pin}&imei=352021103978789`
      )
      .then((res) => {
        if (res.data.status == 0) {
          commit("SetTranstions", res.data.transactions);
        } else {
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message);
        }
      })
      .catch((err) => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message);
      })
      .finally(() => {
        commit("setloading", false);
      });
  },
  searchByDate({ commit }, payload) {
    commit("setloading", true);
    commit("setSnackbar", false);
    axios
      .post(
        `https://backoffice.teller.ng/api/TransactionHistoryWeb?customerID=${payload.customerID}&pin=${payload.pin}&dateTo=${payload.dateTo}&dateFrom=${payload.dateFrom}&pageSize=${payload.pageSize}&page=${payload.page}`
      )
      .then((res) => {
        if (res.data.status == 0) {
          console.log(res.data);
          commit("SetPagination", res.data);
          commit("SetTranstions", res.data.transactions);
        } else {
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message);
        }
      })
      .catch((err) => {
        commit("setSnackbar", true);
        commit("setServerMessage", err.message);
      })
      .finally(() => {
        commit("setloading", false);
      });
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
